import React from "react";

const ChartSummaryRows = ({ rows = [] }) => {
  const visibleRows = rows.filter((row) => row && row.show !== false);

  if (!visibleRows.length) return null;

  return (
    <div className="risk-chart-summary">
      {visibleRows.map((row) => (
        <div className="risk-chart-summary-badge" key={row.label}>
          <span
            className="risk-chart-summary-dot"
            style={{
              background: row.color,
            }}
          />
          <span>{row.label}: {row.value}</span>
        </div>
      ))}
    </div>
  );
};

export default ChartSummaryRows;
